export const useClient = () => {
  const config = useRuntimeConfig();

  // Using hardcoded OnePass as client name to ensure consistent capitalization
  const clientName = "onepass";
  console.log("Client name:", config.public.CLIENT_NAME);
  // Always returning proper brand name with correct capitalization
  const clientNameCapitalized = "OnePass";

  // Handle React Native WebView communication with proper error handling
  const isReactNativeWebView = computed(() => {
    return typeof window !== "undefined" && !!window.ReactNativeWebView;
  });

  // Safe method to communicate with React Native WebView
  const sendMessageToReactNative = (message: any): boolean => {
    if (!isReactNativeWebView.value) return false;

    try {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
        return true;
      }
    } catch (error) {
      console.warn("Failed to communicate with React Native WebView:", error);
    }
    return false;
  };

  // For OnePass, use the SVG logo we created, otherwise fallback to PNG
  const getLogoSrc = () => {
    if (clientName === "onepass") {
      // For direct public access, we'll copy our SVG to the public directory
      return "/onepass-mobile-primary-logo.svg";
    }
    return `/img/logo_${clientName}.png`;
  };

  return {
    clientName,
    clientNameCapitalized,
    logoSrc: computed(() => getLogoSrc()),
    logoAlt: computed(() => `Home - ${clientNameCapitalized} mobile Logo`),
    logoRole: computed(() => `${clientNameCapitalized} Home Page`),
    isReactNativeWebView,
    sendMessageToReactNative,
  };
};
